import { LoadUnsplashSearchProps, UnsplashResponse } from '@components/add-image';
import { TriggerUnsplashDownloadProps } from '@components/add-image/unsplash-api';

import { request } from 'api/request';

export const loadUnsplashSearch = async ({ search, page, pageSize }: LoadUnsplashSearchProps) => {
  const response = await request.get<UnsplashResponse>(
    `v1/photos/unsplash/search?page_size=${pageSize}&page=${page}&search=${search}`
  );
  return response.data;
};

export const triggerUnsplashDownload = async ({ slug, ixid }: TriggerUnsplashDownloadProps) => {
  const response = await request.get(
    `v1/photos/unsplash/trigger-download?slug=${slug}&ixid=${ixid}`
  );
  return response.data;
};
